export default __webpack_public_path__ + "static/media/whiteTwitter.289ecc68.svg";